export const NO_SIGNAL_ICON = 'mdi-wifi-alert';
export const NOT_MOUNTED_ICON = 'mdi-alert-outline';
export const NO_ENTRY_ICON = 'mdi-cancel';
